import { GoalResponseDto } from '../dto/response/goal-response.dto';
import { GoalSaveRequestDto } from '../dto/request/goal-save-request.dto';
import { GoalUpdateRequestDto } from '../dto/request/goal-update-request.dto';
import { BaseLandscapeService } from '../../base-landscape.service';
import {
  getLanguageKey,
  LocalesLanguagesConstants,
} from '../../../../locales/locales';

class GoalService extends BaseLandscapeService {
  public async fetchGoals(): Promise<GoalResponseDto[]> {
    const response = await this.get<GoalResponseDto[]>(`/goal`);
    return response.data;
  }

  public async fetchGoalById(
    id: string,
    language: LocalesLanguagesConstants = LocalesLanguagesConstants.en
  ): Promise<GoalResponseDto> {
    const response = await this.get<GoalResponseDto>(`/goal/${id}`, {
      headers: {
        'accept-language': getLanguageKey(language),
      },
    });
    return response.data;
  }

  public async saveGoal(
    saveRequest: GoalSaveRequestDto,
    language: LocalesLanguagesConstants = LocalesLanguagesConstants.en
  ): Promise<GoalResponseDto> {
    const response = await this.post<GoalResponseDto>(`/goal`, saveRequest, {
      headers: {
        'accept-language': getLanguageKey(language),
      },
    });
    return response.data;
  }

  public async updateGoal(
    updateRequest: GoalUpdateRequestDto,
    language: LocalesLanguagesConstants = LocalesLanguagesConstants.en
  ): Promise<GoalResponseDto> {
    const response = await this.put<GoalResponseDto>(`/goal`, updateRequest, {
      headers: {
        'accept-language': getLanguageKey(language),
      },
    });
    return response.data;
  }

  public async deleteGoal(existingId: string): Promise<void> {
    await this.delete<void>(`/goal/${existingId}`);
  }
}

const goalService = new GoalService();
export default goalService;
